import { useMemo, useState } from 'react';

const useAssignmentEditorDialogs = () => {
    const [selectRubricDialog, setSelectRubricDialog] = useState({ open: false });
    const [createRubricDialog, setCreateRubricDialog] = useState({ open: false });
    const [createRubricExistingDialog, setCreateRubricExistingDialog] = useState({ open: false });
    const [createRubricAIDialog, setCreateRubricAIDialog] = useState({ open: false });
    const [editRubricDialog, setEditRubricDialog] = useState({ open: false, customDefaultForm: null });
    const [uploadContentBankResourcesDialog, setUploadContentBankResourcesDialog] = useState({ open: false });
    const [editContentBankResourcesDialog, setEditContentBankResourcesDialog] = useState({ open: false });
    const [pushRubricDialog, setPushRubricDialog] = useState({ open: false });

    return useMemo(
        () => ({
            selectRubricDialog,
            setSelectRubricDialog,
            createRubricDialog,
            setCreateRubricDialog,
            createRubricExistingDialog,
            setCreateRubricExistingDialog,
            createRubricAIDialog,
            setCreateRubricAIDialog,
            editRubricDialog,
            setEditRubricDialog,
            uploadContentBankResourcesDialog,
            setUploadContentBankResourcesDialog,
            editContentBankResourcesDialog,
            setEditContentBankResourcesDialog,
            pushRubricDialog,
            setPushRubricDialog,
        }),
        [
            createRubricAIDialog,
            createRubricExistingDialog,
            createRubricDialog,
            editContentBankResourcesDialog,
            editRubricDialog,
            pushRubricDialog,
            selectRubricDialog,
            uploadContentBankResourcesDialog,
        ]
    );
};

export default useAssignmentEditorDialogs;
